if (!customElements.get('pt-navigation')) {
  customElements.define('pt-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.toggles = [...this.querySelectorAll('[data-nav-toggle]')];
      this.desktop = this.dataset.mode === 'desktop';
      this.toggles.forEach(button => {
        const group = button.closest('.pt-nav-group');
        button.addEventListener('click', () => this.toggle(button), opts);
        group.addEventListener('pointerenter', event => {
          if (!this.desktop || event.pointerType !== 'mouse') return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.open(button), 140);
        }, opts);
        group.addEventListener('pointerleave', () => {
          if (!this.desktop) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            if (!group.contains(document.activeElement)) this.close(button);
          }, 220);
        }, opts);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const button = this.toggles.find(item => item.getAttribute('aria-expanded') === 'true');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        this.escapeHandled = true;
        this.close(button);
        button.focus();
      }, opts);
      this.addEventListener('keyup', event => {
        if (event.key === 'Escape' && this.escapeHandled) { event.stopPropagation(); this.escapeHandled = false; }
      }, opts);
      this.addEventListener('focusout', event => {
        if (this.desktop && event.relatedTarget && !this.contains(event.relatedTarget)) this.closeAll();
      }, opts);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, opts);
      this.viewport = matchMedia('(min-width: 1200px)');
      this.viewport.addEventListener('change', () => {
        this.closeAll();
        const drawer = this.closest('header-drawer');
        if (drawer && this.viewport.matches) drawer.dispatchEvent(new CustomEvent('drawer:force-close'));
      }, opts);
      this.querySelectorAll('a').forEach(link => {
        if (new URL(link.href).pathname === location.pathname && !link.hash) link.setAttribute('aria-current', 'page');
        link.addEventListener('click', () => {
          if (link.hash && new URL(link.href).pathname === location.pathname) {
            this.closeAll();
            this.closest('header-drawer')?.dispatchEvent(new CustomEvent('drawer:force-close'));
          }
        }, opts);
      });
    }
    open(button) {
      this.closeAll(button);
      button.setAttribute('aria-expanded', 'true');
      document.getElementById(button.getAttribute('aria-controls')).hidden = false;
    }
    close(button) {
      button.setAttribute('aria-expanded', 'false');
      document.getElementById(button.getAttribute('aria-controls')).hidden = true;
    }
    closeAll(except) {
      clearTimeout(this.timer);
      this.toggles.forEach(button => { if (button !== except) this.close(button); });
    }
    toggle(button) {
      clearTimeout(this.timer);
      button.getAttribute('aria-expanded') === 'true' ? this.close(button) : this.open(button);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  });
}
